/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreatePepCheck {
  readonly user: string;
  readonly added_by: string | null;
  readonly comment: string;
  readonly status: string;
}
